import { useTranslation } from 'react-i18next'

import { cn } from '@shared/lib/cn'
import { LocalizedLink as Link } from '@shared/lib/locale'

import styles from './styles.module.scss'



interface BreadcrumbsProps extends React.HTMLProps<HTMLUListElement> {
  className?: string;
  links: {
    title: string;
    to?: string;
  }[];
}

export default function Breadcrumbs (props: BreadcrumbsProps) {
  const { links, className, ...rest } = props
  const { t: tn } = useTranslation('navigation')

  return (
    <ul className={cn(styles.root, 'reset-list', className)} {...rest}>
      <li className={styles.root__item}>
        <Link className={styles.root__link} to={'/'}>
          {tn('main')}
          <span className={styles.root__circle}></span>
        </Link>
      </li>

      {links.map((link, index) => {
        return (
          <li className={styles.root__item} key={index}>
            {link.to && (
              <Link className={styles.root__link} to={link.to}>
                {link.title}
                <span className={styles.root__circle}></span>
              </Link>
            )}

            {!link.to && (
              <span className={styles.root__current}>{link.title}</span>
            )}
          </li>
        )
      })}
    </ul>
  )
}
